export interface ListProductType {
  id: number
  productName: string
  type: string
  Amount: number
  brainFunctionMapping?: number
  HRV?: number
  MCI?: number
  PBM?: number
  charge: number
  org: string
  duration: number
}

export const DEDUCTIONS = 1

export const PAYMENT_STATUS = {
  CREATED: 'CREATED',
  REQUESTED: 'REQUESTED',
  CANCELLED: 'CANCELLED',
  PENDING: 'PENDING',
  EXPIRED: 'EXPIRED',
  FAILED: 'FAILED',
  APPROVED: 'APPROVED',
  APPROVED_INVALID: 'APPROVED_INVALID',
  REQUEST_REFUND: 'REQUEST_REFUND',
  PENDING_REFUND: 'PENDING_REFUND',
  PARTIALLY_REFUNDED: 'PARTIALLY_REFUNDED',
  REFUNDED: 'REFUNDED',
}

export const PAYMENT_SUCCESS = [
  PAYMENT_STATUS.APPROVED,
  PAYMENT_STATUS.REFUNDED,
]

export const NATION_CODE = {
  KR: 'KR',
  US: 'US',
}

export const PAYMENT_FAILED = [PAYMENT_STATUS.FAILED, PAYMENT_STATUS.CANCELLED]
export const FILTERED_PACKAGE_ID = ['1', '8']
export const NORM_PACKAGE_ID = ['5', '6']
export const PACKAGE_AVAILABLE_IMAGE_ID = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '27',
  '28',
  '29',
]
